import { combineReducers } from 'redux'
import city from './city'
import get from 'lodash/get'
import { handleActions } from 'redux-actions'
import { createPromiseAction } from 'utils/asyncActions'

export const fetchAds = createPromiseAction('unicorn/homescreen/ads/FETCH_ADS')

const initState = { ads: [], checkoutAds: [], walletAds: [], heroAds: [] }

const ads = handleActions(
  {
    [fetchAds]: state => ({ ...state }),
    [fetchAds.fulfilled]: (state, { payload }) => {
      return ({
        ...state,
        ...payload,
      })
    },
  },
  initState,
)

export default combineReducers({ city, ads })

export const getCity = state => state.homepage.city
export const getAds = state => get(state,'homepage.ads.ads',[])
export const getHeroAds = state => get(state,'homepage.ads.heroAds',[])
export const selectPopupAds = state => get(state,'homepage.ads.popupAds',[])
